<template>
    <div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad">
                <ul class="card">
                    <li v-for="(item,index) in dataList" :key="item.stageName+index" @click="toFarmDetail(item)" >
                        <img :src="item.images[0]">
                        <h6>
                            <span class="card-title">{{item.cropName}}·{{item.breedName}}</span>
                            <label class="card-subtitle">
                                {{item.plantingDate && moment(item.plantingDate).format('MM月DD日')}}
                                - {{item.stageName}}</label>
                        </h6>
                        <span class="record">{{item.plantingNoteNum}}条记录</span>
                    </li>
                </ul>
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
    import moment from "moment"
    export default {
        data(){
            return{
                moment,
                details:'',
                loading: false,
                finished: false,
                refreshing: false,
                dataList:[],
                sendData:{
                    current:0,
                    size: 20,
                    grangeId:''
                },
                total:0,
            }
        },
        created() {
            this.sendData.grangeId = this.$route.query && this.$route.query.grangeId
        },
        methods:{
            /*
            * 获取列表
            * */
            getPlantingPage(){
                let {sendData} = this
                this.$api.getPlantingPage(sendData).then(res => {
                    this.total = res.data.total
                    let rows = res.data.records  //请求返回当页的列表

                    if(rows === null || rows.length === 0){
                        this.finished = true
                        return
                    }

                    this.loading = false
                    this.dataList = [ ...this.dataList , ...rows ]

                    if(this.dataList.length >= this.total){
                        this.finished = true
                    }

                    setTimeout(() => {
                        this.refreshing = false
                    },1000)

                })
            },


            onLoad() {
                // 异步更新数据
                setTimeout(() => {
                    this.sendData.current++
                    this.getPlantingPage()
                }, 2000);
            },

            onRefresh() {
                this.sendData.current = 1
                this.dataList = []
                this.getPlantingPage()
            },

            toFarmDetail(value){
                let p ={
                    farmlandId: value.id,
                    cropName: value.cropName,
                    breedName: value.breedName,
                    images:value.images[0],
                }
                this.$router.push({name:'farmDetail' , query:{data:JSON.stringify(p)}})
            },

        }
    }
</script>

<style scoped lang="scss">
    @import './css/index';
</style>